import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const fetchVendorData = async () => {
  const response = await axios.get(`${API_URL}/vendordetails`);
  if (response.status === 204) {
    return [];
  }

  if (response.status === 200) {
    return response.data.vendor;
  }

  throw new Error("Unexpected response");
};

export const useVendor = () => {
  return useQuery({
    queryKey: ["vendor"],
    queryFn: fetchVendorData,
    staleTime: 1000 * 60 * 60, // 1 hour
    refetchInterval: 1000 * 60 * 60, // Refetch every 1 hour
    retry: 3, // Retry on failure
    refetchOnWindowFocus: false, // Disable refetching when window regains focus
  });
};
